import { userByUsernameQueryOptions, userQueryOptions } from '@/api/queries/users';
import { isUsername } from '@/utils/username';
import { useQuery } from '@tanstack/react-query';

export function useProfileByIdentifier(rawIdentifier: string | string[] | undefined) {
  const identifier = typeof rawIdentifier === 'string' ? rawIdentifier : rawIdentifier?.[0] || '';
  const isUsernameParam = !!(identifier && isUsername(identifier));

  const usernameQuery = useQuery({
    ...userByUsernameQueryOptions(identifier),
    enabled: !!(isUsernameParam && identifier),
  });

  const userIdQuery = useQuery({
    ...userQueryOptions(identifier),
    enabled: !!(!isUsernameParam && identifier),
  });

  const activeQuery = isUsernameParam ? usernameQuery : userIdQuery;

  return {
    profileData: activeQuery.data,
    isLoading: activeQuery.isLoading,
    error: activeQuery.error,
    refetch: activeQuery.refetch,
    isRefetching: activeQuery.isRefetching,
  };
}
